function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function initDynamicDiscounts() {
  const discountElements = document.querySelectorAll(".dynamic-percentage");
  const discountCodes = window.discountCodes;
  let urlDiscount = new URLSearchParams(window.location.search).get("discount");

  if (!urlDiscount) {
    urlDiscount = new URLSearchParams(window.location.search).get("srccode");
  }

  if (urlDiscount) {
    let host = window.location.hostname.toUpperCase();
    let codeUpperCase = urlDiscount.toUpperCase();
    if (codeUpperCase === "GPOSLT") {
      urlDiscount = "GPSLT";
    } else if (
      host === "WWW.STATELINETACK.COM" &&
      codeUpperCase.startsWith("AD")
    ) {
      urlDiscount = "SLT20";
    }
  }

  const pathDiscount = window.location.pathname.split("/discount/")[1];
  // grab incoming google discount code if present and variant id
  const googleDiscountCode = new URLSearchParams(window.location.search).get(
    "pv2",
  );
  const urlVariant = new URLSearchParams(window.location.search).get("variant");

  discountElements.forEach((element) => {
    // Grab potential discount codes from URL or path

    let newDiscountCode = null;
    let newDiscountMessage = null;
    //let discountSize = null;
    let cartCode = null;

    // Decide if a new code is present
    if (urlDiscount && discountCodes[urlDiscount]) {
      newDiscountMessage = discountCodes[urlDiscount];
      newDiscountCode = urlDiscount;
    } else if (urlDiscount && urlDiscount === discountCodes.default_code) {
      newDiscountMessage = discountCodes.default_text;
      newDiscountCode = urlDiscount;
    } else if (pathDiscount && discountCodes[pathDiscount]) {
      newDiscountMessage = discountCodes[pathDiscount];
      newDiscountCode = pathDiscount;
    } else if (pathDiscount && pathDiscount === discountCodes.default_code) {
      newDiscountMessage = discountCodes.default_text;
      newDiscountCode = pathDiscount;
    }

    if (newDiscountMessage) {
      // If a new discount code is found, use it and overwrite localStorage
      element.textContent = newDiscountMessage;
      localStorage.setItem("discount", newDiscountCode);
      localStorage.setItem("discountMessage", newDiscountMessage);
      document.body.setAttribute("data-dynamic-discount", "true");
      document.body.setAttribute("data-discount-size", newDiscountCode);
      cartCode = newDiscountCode;
    } else {
      // Otherwise, fall back to saved discount
      const savedDiscount = localStorage.getItem("discount");
      const savedDiscountMessage = localStorage.getItem("discountMessage");

      if (savedDiscount && savedDiscountMessage) {
        element.textContent = savedDiscountMessage;
        const savedDiscountSize = savedDiscount;
        document.body.setAttribute("data-dynamic-discount", "true");
        document.body.setAttribute("data-discount-size", savedDiscountSize);
      } else {
        document.body.setAttribute("data-dynamic-discount", "false");
        document.body.removeAttribute("data-discount-size");
      }
    }

    // check if code is still valid, if it's not, clear
    let currentCode = localStorage.getItem("discount");
    if (currentCode && Object.keys(discountCodes).indexOf(currentCode) < 0) {
      localStorage.removeItem("discount");
      localStorage.removeItem("discountMessage");
      document.body.setAttribute("data-dynamic-discount", "false");
      document.body.removeAttribute("data-discount-size");
    }

    if (discountCodes["default_code"] && discountCodes["default_text"]) {
      localStorage.setItem("default_discount", discountCodes["default_code"]);
      localStorage.setItem(
        "default_discountMessage",
        discountCodes["default_text"],
      );
      // no code, set a default if present
      currentCode = localStorage.getItem("discount");
      if (!currentCode) {
        cartCode = discountCodes["default_code"];
        localStorage.setItem("discount", discountCodes["default_code"]);
        localStorage.setItem("discountMessage", discountCodes["default_text"]);
        document.body.setAttribute("data-dynamic-discount", "true");
        document.body.setAttribute(
          "data-discount-size",
          discountCodes["default_code"],
        );
        element.textContent = discountCodes["default_text"];
      }
    } // no default code
    else {
      localStorage.removeItem("default_discount");
      localStorage.removeItem("default_discountMessage");
    }

    element.style.visibility = "visible";

    // test for hidden field, if so check against current code and also append any google automatic discount items
    // the metafield is coded as discountcode=123456|variantidstoesclude=123456,234567
    let hiddenField = document.getElementById("cart_metadata")?.value;
    let hiddenFieldCode = "";
    let currentGoogleDiscountVariantIDs = "";
    let newFullCartmetafield = "discountcode=";
    if (hiddenField && hiddenField.startsWith("discountcode=")) {
      let sep = hiddenField.indexOf("|");
      if (sep > 0) {
        hiddenFieldCode = hiddenField.substring(13, sep);
      } else {
        hiddenFieldCode = hiddenField.substring(13);
      }

      if (cartCode) {
        // incoming code
        newFullCartmetafield += cartCode;
      } else if (currentCode) {
        newFullCartmetafield += currentCode;
      } else if (localStorage.getItem("default_code")) {
        newFullCartmetafield += localStorage.getItem("default_code");
      } // code currently on cart
      else {
        if (hiddenFieldCode) {
          newFullCartmetafield += hiddenFieldCode;
        } else {
          cartCode = localStorage.getItem("discount");
          if (!cartCode) cartCode = localStorage.getItem("default_code");
          if (cartCode) newFullCartmetafield += cartCode;
        }
      }
    } else {
      if (cartCode) {
        newFullCartmetafield += cartCode;
      } else {
        cartCode = localStorage.getItem("discount");
        if (!cartCode) cartCode = localStorage.getItem("default_code");
        if (cartCode) newFullCartmetafield += cartCode;
      }
    }

    // check for any existing variants
    if (hiddenField && hiddenField.includes("variantidstoesclude=")) {
      currentGoogleDiscountVariantIDs = hiddenField.substring(
        hiddenField.indexOf("variantidstoesclude="),
      );
    }

    // when we find a google discount and a variant, save it to the metafield list
    if (googleDiscountCode && urlVariant) {
      if (!currentGoogleDiscountVariantIDs.includes(urlVariant)) {
        if (currentGoogleDiscountVariantIDs.length > 0) {
          currentGoogleDiscountVariantIDs += "," + urlVariant;
        } else {
          currentGoogleDiscountVariantIDs = "variantidstoesclude=" + urlVariant;
        }
      }
    }

    if (currentGoogleDiscountVariantIDs) {
      newFullCartmetafield += "|" + currentGoogleDiscountVariantIDs;
    }

    //console.log("loca storage code = " + localStorage.getItem("discount"));
    //console.log("newFullCartmetafield: " + newFullCartmetafield);
    //console.log("hiddenField: " + hiddenField);

    // if we hav e a new code, and it's different than whats currently on the cart
    if (newFullCartmetafield && newFullCartmetafield !== hiddenFieldCode) {
      // set code on cart as an attribute for use in functions calculating cart discounts, it will also show up on order data
      //console.log("Setting cart meta to - " + newFullCartmetafield);
      //fetch('/cart/update.js', {
      //  method: 'POST',
      //  headers: {
      //    'Content-Type': 'application/json',
      //    'Accept': 'application/json'
      //  },
      //  body: JSON.stringify({
      //    attributes: {
      //      client_discount_code: newFullCartmetafield,
      //    }
      //  })
      //})
      //.then(response => response.json())
      //.then(data => {
      //  //console.log('Cart updated:', data);
      //});
      var hidenMetaFieldForUpdate = document.getElementById("cart_metadata");
      if (hidenMetaFieldForUpdate)
        document.getElementById("cart_metadata").value = newFullCartmetafield;
    }
  });
}

initDynamicDiscounts();

function updateBannerUrl() {
  let currentCode = localStorage.getItem("discount");
  if (!currentCode) currentCode = localStorage.getItem("default_discount");
  if (!currentCode) return;

  const discountBannerLinkUrls = window.discountBannerLinkUrls;
  if (Object.keys(discountBannerLinkUrls).indexOf(currentCode) >= 0) {
    let banner = document.querySelector(".announcement-bar__link");
    if (banner) {
      banner.href = discountBannerLinkUrls[currentCode];
    }
  }
}

updateBannerUrl();

function setDiscountFromUrl() {
  let urlDiscount = new URLSearchParams(window.location.search).get("discount");

  if (!urlDiscount) {
    urlDiscount = new URLSearchParams(window.location.search).get("srccode");
  }

  if (urlDiscount && urlDiscount === "GPOSLT") {
    urlDiscount = "GPSLT";
  }

  //console.log("loyaltyDiscount", urlDiscount);
  if (urlDiscount) localStorage.setItem("_tcdiscount", urlDiscount);
}
setDiscountFromUrl();

function setLoyalty() {
  let status = "NONE";

  if (typeof _ALConfig !== "undefined" && _ALConfig !== null) {
    status = _ALConfig.customerLoyalty?.customerStatus ?? "INACTIVE";
  }

  localStorage.setItem("_tcloyalty", status);
}
setLoyalty();

function updateInputsFromStorage(html, selector, key) {
  //console.log("mv getting from storage for ", key);
  var inputs = html.querySelectorAll(selector);
  inputs.forEach(function (input) {
    //console.log("mv setting from storage " + key, localStorage.getItem(key));
    input.value = localStorage.getItem(key) || "";
  });
}

function updateAttributes(html) {
  updateInputsFromStorage(html, 'input[id="__loyaltyStatus"]', "_tcloyalty");
  updateInputsFromStorage(html, 'input[id="__discountCode"]', "_tcdiscount");
}
updateAttributes(document);

// Save loyalty and discount to cart attributes
(() => {
  let clientDiscountCode = "";
  var hidenMetaFieldForUpdate = document.getElementById("cart_metadata");
  if (hidenMetaFieldForUpdate)
    clientDiscountCode = hidenMetaFieldForUpdate.value;

  // Build attributes object and include AB test variant when available
  const _cartAttributes = {
    loyaltyStatus: localStorage.getItem("_tcloyalty"),
    discountCode: localStorage.getItem("discount"),
    client_discount_code: clientDiscountCode,
  };
  if (
    typeof window._AB_VARIANT !== "undefined" &&
    window._AB_VARIANT !== null
  ) {
    _cartAttributes.abVariant = window._AB_VARIANT;
  }

  if (window._ALConfig) {
    _cartAttributes.CustomerLoyaltyAvailablePoints =
      window._ALConfig.customerLoyalty?.availablePoints || 0;
  }

  window
    .fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: _cartAttributes }),
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Cart updated:", data);
    });
})();

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = [],
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`,
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if (!container) return;

  var elements = getFocusableElements(container) || [];
  if (!elements.length) {
    // Nothing focusable inside container — clean up any previous traps and
    // attempt to focus the fallback element if provided.
    removeTrapFocus();
    try {
      if (elementToFocus && typeof elementToFocus.focus === "function")
        elementToFocus.focus();
    } catch (e) {
      /* ignore */
    }
    return;
  }

  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min),
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === "") {
        const productUrl = this.dataset.url.split("?")[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const sourceQty = html.querySelector(
              ".quick-order-list-container",
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`,
      ),
    );
  }
}

customElements.define("bulk-modal", BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Read initial-top-option-position emitted by server to know which
    // option is rendered on top for the first paint.
    try {
      const topScript = this.querySelector(
        'script[type="application/json"][data-initial-top-option-position]',
      );
      this._initialTopOptionPosition = topScript
        ? JSON.parse(topScript.textContent.trim())
        : null;
    } catch (e) {
      this._initialTopOptionPosition = null;
    }
    // Track whether the user has interacted with options yet.
    this._initialTopInteracted = false;
    this._clearingSelection = false;

    // Preserve server-rendered enabled state for the initial top option
    // immediately on connect so the UI doesn't show crossed-out values
    // before any client-side availability recalculation runs.
    try {
      if (this._initialTopOptionPosition) this._preserveInitialTopOptionUI();
    } catch (e) {
      /* best-effort */
    }

    this.addEventListener("change", (event) => {
      if (this._clearingSelection) return;

      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      // Mark that user has actively changed selection (interaction)
      this._initialTopInteracted = true;

      // Track whether this change cleared other selections so we can
      // conditionally ask the server to suppress restoring previous
      // client selections. Use a local flag to avoid races with
      // _clearingSelection state.
      let didClearOtherSelections = false;

      // If the user changed the top option, and the combination of the
      // new top value + currently selected other options has NO available
      // variant, clear the other option selections so the user must pick
      // them (this will disable the add-to-cart button via product-info).
      try {
        const changedGroup = event.target.closest
          ? event.target.closest("[data-option-position]")
          : null;
        console.log("variant-selects: change event", {
          target: event.target && event.target.id,
          value: event.target && event.target.value,
        });
        const changedPos = changedGroup
          ? parseInt(changedGroup.dataset.optionPosition || "", 10)
          : null;
        const topPos = this._initialTopOptionPosition
          ? parseInt(this._initialTopOptionPosition, 10)
          : null;
        console.log("variant-selects: changedPos/topPos", {
          changedPos,
          topPos,
        });
        if (topPos && changedPos && changedPos === topPos) {
          const variants = this._getVariants();
          console.log("variant-selects: variants length", variants.length);
          if (Array.isArray(variants) && variants.length) {
            const selectedByPosition = this._getSelectedByPosition();
            console.log(
              "variant-selects: selectedByPosition",
              selectedByPosition,
            );

            // If there's any selected other position, check for a matching available variant
            const otherSelectedExists = Object.keys(selectedByPosition).some(
              (k) => parseInt(k, 10) !== topPos,
            );

            if (otherSelectedExists) {
              const match = variants.find((v) => {
                if (!v.available) return false;
                for (const [posKey, selectedValue] of Object.entries(
                  selectedByPosition,
                )) {
                  const pos = parseInt(posKey, 10);
                  if (!selectedValue) continue;
                  if (pos === topPos) {
                    if ((v[`option${pos}`] || "") !== selectedValue)
                      return false;
                    continue;
                  }
                  if ((v[`option${pos}`] || "") !== selectedValue) return false;
                }
                return true;
              });

              if (!match) {
                console.log(
                  "variant-selects: no match for new top + current other selections; will clear other selections",
                  { selectedByPosition },
                );
                // No available variant matches the new top + current other selections.
                // Clear other selections.
                this._clearingSelection = true;
                didClearOtherSelections = true;
                try {
                  const groups = Array.from(
                    this.querySelectorAll("[data-option-position]"),
                  );
                  groups.forEach((group) => {
                    const pos = parseInt(
                      group.dataset.optionPosition || "",
                      10,
                    );
                    if (pos === topPos) return;

                    const select = group.querySelector("select");
                    if (select) {
                      // clear select selection
                      Array.from(select.options).forEach((opt) =>
                        opt.removeAttribute("selected"),
                      );
                      select.value = "";
                      this.updateSelectionMetadata({ target: select });
                      return;
                    }

                    // clear radio inputs
                    const radios = Array.from(
                      group.querySelectorAll('input[type="radio"]'),
                    );
                    radios.forEach((r) => {
                      r.checked = false;
                    });
                    // update label/display for the group
                    const anyInput = group.querySelector("input");
                    if (anyInput)
                      this.updateSelectionMetadata({ target: anyInput });
                  });
                  console.log("variant-selects: cleared other selections", {
                    didClearOtherSelections,
                  });

                  // After clearing other selections, fall through so we publish
                  // the final selection state below (so product-info will use
                  // the cleared selections when building its fetch URL).
                } finally {
                  this._clearingSelection = false;
                }
              }
            }
          }
        } else if (topPos && changedPos && changedPos !== topPos) {
          const variants = this._getVariants();
          if (Array.isArray(variants) && variants.length) {
            const selectedByPosition = this._getSelectedByPosition();

            const hasTopSelection = Boolean(selectedByPosition[topPos]);
            const hasAnyMatchingAvailableVariant = variants.some((v) => {
              if (!v.available) return false;
              for (const [posKey, selectedValue] of Object.entries(
                selectedByPosition,
              )) {
                const pos = parseInt(posKey, 10);
                if (!selectedValue) continue;
                if ((v[`option${pos}`] || "") !== selectedValue) return false;
              }
              return true;
            });

            // If the user clicked a non-top option and that leaves us without
            // a full available match (or top is unselected), auto-pick the
            // top-row value with the highest in-stock quantity that matches
            // the user's non-top selections.
            if (!hasTopSelection || !hasAnyMatchingAvailableVariant) {
              const quantityForVariant = (variant) => {
                const vm = window.variantMetafields?.[variant.id];
                const qty =
                  vm?.qohlocal ??
                  vm?.custom?.qohlocal ??
                  variant.inventory_quantity ??
                  0;
                const parsed = parseInt(qty, 10);
                return Number.isNaN(parsed) ? 0 : parsed;
              };

              const candidates = variants.filter((v) => {
                if (!v.available) return false;
                for (const [posKey, selectedValue] of Object.entries(
                  selectedByPosition,
                )) {
                  const pos = parseInt(posKey, 10);
                  if (pos === topPos) continue;
                  if (!selectedValue) continue;
                  if ((v[`option${pos}`] || "") !== selectedValue) return false;
                }
                return true;
              });

              if (candidates.length) {
                const bestCandidate = candidates.reduce((best, current) => {
                  const bestQty = quantityForVariant(best);
                  const currentQty = quantityForVariant(current);
                  return currentQty > bestQty ? current : best;
                }, candidates[0]);

                const bestTopValue = (bestCandidate[`option${topPos}`] || "")
                  .toString()
                  .trim();

                if (bestTopValue) {
                  this._clearingSelection = true;
                  didClearOtherSelections = true;
                  try {
                    const topGroup = this.querySelector(
                      `[data-option-position="${topPos}"]`,
                    );
                    if (topGroup) {
                      const topSelect = topGroup.querySelector("select");
                      if (topSelect) {
                        const targetOption = Array.from(topSelect.options).find(
                          (opt) =>
                            String(
                              opt.value || opt.textContent || "",
                            ).trim() === bestTopValue,
                        );
                        if (targetOption) {
                          Array.from(topSelect.options).forEach((opt) =>
                            opt.removeAttribute("selected"),
                          );
                          topSelect.value = targetOption.value;
                          targetOption.setAttribute("selected", "selected");
                          this.updateSelectionMetadata({
                            target: targetOption,
                          });
                        }
                      } else {
                        const topRadios = Array.from(
                          topGroup.querySelectorAll('input[type="radio"]'),
                        );
                        const targetRadio = topRadios.find(
                          (radio) =>
                            String(radio.value || "").trim() === bestTopValue,
                        );
                        if (targetRadio) {
                          topRadios.forEach((r) => {
                            r.checked = false;
                          });
                          targetRadio.checked = true;
                          this.updateSelectionMetadata({ target: targetRadio });
                        }
                      }
                    }
                  } finally {
                    this._clearingSelection = false;
                  }
                }
              }
            }
          }
        }
      } catch (e) {
        /* best-effort */
      }

      // If we cleared other selections, set a suppression flag on the
      // enclosing `product-info` so it won't restore prior client
      // selections when replacing the `variant-selects` HTML.
      try {
        if (didClearOtherSelections) {
          const productInfo = this.closest && this.closest("product-info");
          if (productInfo) productInfo._suppressVariantSelectorRestore = true;
        }
      } catch (e) {
        /* best-effort */
      }

      // Publish a single option-value selection change reflecting the
      // final state (may have been cleared above). Only include the
      // suppress flag in the event payload when we actually cleared
      // dependent selections.
      console.log("variant-selects: publishing optionValueSelectionChange", {
        didClearOtherSelections,
        selectedOptionValues: this.selectedOptionValues,
      });
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: Object.assign(
          {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
          didClearOtherSelections
            ? { suppressVariantSelectorRestore: true }
            : {},
        ),
      });

      this.recalculateAvailability();
    });

    // Also mark initial interaction on any pointerdown inside variant-selects
    // to ensure we re-enable normal availability behavior after first click.
    this.addEventListener(
      "pointerdown",
      (e) => {
        if (!this._initialTopInteracted) {
          const t = e.target;
          if (
            t &&
            (t.tagName === "INPUT" ||
              t.tagName === "SELECT" ||
              (t.closest && t.closest(".product-form__input")))
          ) {
            this._initialTopInteracted = true;
          }
        }
      },
      { capture: true },
    );
  }

  _preserveInitialTopOptionUI() {
    const pos = parseInt(this._initialTopOptionPosition, 10);
    if (!pos) return;
    const group = Array.from(
      this.querySelectorAll("[data-option-position]"),
    ).find((g) => parseInt(g.dataset.optionPosition || "", 10) === pos);
    if (!group) return;

    // For selects: ensure options are enabled and not visually disabled
    const select = group.querySelector("select");
    if (select) {
      Array.from(select.options).forEach((opt) => {
        opt.removeAttribute("disabled");
        opt.classList.remove("disabled");
      });
    }

    // For radio/swatch inputs: remove disabled markers and swatch-unavailable
    const inputs = Array.from(
      group.querySelectorAll(
        'input[type="radio"], input[data-option-value-id]',
      ),
    );
    inputs.forEach((input) => {
      input.classList.remove("disabled");
      input.removeAttribute("disabled");
      input.setAttribute(
        "aria-label",
        (input.getAttribute("aria-label") || "").replace(" - out of stock", ""),
      );
    });
    const swatch = group.querySelector(".swatch");
    if (swatch) swatch.classList.remove("swatch--unavailable");
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset",
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
      );
    } else if (tagName === "SELECT") {
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        ?.querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      selectedDropdownSwatchValue.style.setProperty(
        "--swatch--background",
        "unset",
      );
      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        "unset",
      );
      selectedDropdownSwatchValue.classList.add("swatch--unavailable");
    } else if (tagName === "INPUT" && target.type === "radio") {
      const inputGroup = target.closest(`.product-form__input`);
      const selectedSwatchValue = inputGroup?.querySelector(
        "[data-selected-value]",
      );
      if (!selectedSwatchValue) return;

      const checkedInput = inputGroup.querySelector(
        'input[type="radio"]:checked',
      );
      if (checkedInput) {
        selectedSwatchValue.innerHTML = checkedInput.value || value;
      } else {
        selectedSwatchValue.innerHTML = "";
      }
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map(({ dataset }) => dataset.optionValueId);
  }

  _getVariants() {
    try {
      const productInfo = this.closest("product-info");
      const productId = productInfo?.dataset?.productId;
      if (!productId) return [];

      let variants = window.productVariants?.[parseInt(productId, 10)] || [];
      if (!Array.isArray(variants) || variants.length === 0) {
        try {
          const script = this.querySelector(
            'script[type="application/json"][data-variants]',
          );
          if (script && script.textContent && script.textContent.trim()) {
            const parsed = JSON.parse(script.textContent.trim());
            if (Array.isArray(parsed)) variants = parsed;
          }
        } catch (e) {
          /* ignore */
        }
      }

      return Array.isArray(variants) ? variants : [];
    } catch (e) {
      return [];
    }
  }

  _getSelectedByPosition(root = this) {
    const selectedByPosition = {};
    if (!root?.querySelectorAll) return selectedByPosition;

    const selectedElements = Array.from(
      root.querySelectorAll("select option[selected], fieldset input:checked"),
    );

    if (selectedElements.length) {
      selectedElements.forEach((el, idx) => {
        const position =
          parseInt(el.dataset.optionPosition || "", 10) || idx + 1;
        const value = (el.value || el.textContent || "").toString();
        if (value) selectedByPosition[position] = value;
      });

      return selectedByPosition;
    }

    const selects = Array.from(root.querySelectorAll("select"));
    if (selects.length) {
      selects.forEach((select, idx) => {
        const selectedOption = select.options?.[select.selectedIndex];
        const position =
          parseInt(selectedOption?.dataset?.optionPosition || "", 10) ||
          parseInt(
            select.closest("[data-option-position]")?.dataset?.optionPosition ||
              "",
            10,
          ) ||
          idx + 1;
        const value = (
          selectedOption?.value ||
          select.value ||
          selectedOption?.textContent ||
          ""
        ).toString();
        if (value) selectedByPosition[position] = value;
      });

      Array.from(
        root.querySelectorAll(
          "fieldset input:checked, input[type='radio']:checked",
        ),
      ).forEach((input, idx) => {
        const position =
          parseInt(input.dataset.optionPosition || "", 10) ||
          parseInt(
            input.closest("[data-option-position]")?.dataset?.optionPosition ||
              "",
            10,
          ) ||
          idx + 1;
        const value = (input.value || "").toString();
        if (value) selectedByPosition[position] = value;
      });

      return selectedByPosition;
    }

    const groups = Array.from(root.querySelectorAll("[data-option-position]"));
    groups.forEach((group, idx) => {
      const position =
        parseInt(group.dataset.optionPosition || "", 10) || idx + 1;
      const opt = group.querySelector("select option[selected]");
      if (opt) {
        const value = (opt.value || opt.textContent || "").toString();
        if (value) selectedByPosition[position] = value;
        return;
      }
      const radio = group.querySelector("input:checked");
      if (radio) {
        const value = (radio.value || "").toString();
        if (value) selectedByPosition[position] = value;
      }
    });

    return selectedByPosition;
  }

  /**
   * Recalculate availability for option values based on window.productVariants
   */
  recalculateAvailability() {
    try {
      // Ensure we know which option is the initial-top option even if the
      // variant-selects innerHTML was replaced after connect. Some flows
      // replace the inner content (including the script tag) without
      // re-running connectedCallback, so re-read the embedded script here
      // if needed.
      if (!this._initialTopOptionPosition) {
        const topScript = this.querySelector(
          'script[type="application/json"][data-initial-top-option-position]',
        );
        this._initialTopOptionPosition = topScript
          ? JSON.parse(topScript.textContent.trim())
          : this._initialTopOptionPosition;
        // If we now learned the top option and user hasn't interacted,
        // ensure server-rendered UI state is preserved briefly to avoid
        // flicker before we intentionally skip processing below.
        if (this._initialTopOptionPosition && !this._initialTopInteracted) {
          try {
            this._preserveInitialTopOptionUI();
          } catch (e) {
            /* best-effort */
          }
        }
      }

      const productInfo = this.closest("product-info");
      const productId = productInfo?.dataset?.productId;
      if (!productId) return;

      let variants = window.productVariants?.[parseInt(productId, 10)] || [];

      // Fallback: most pages embed variants JSON inside the variant-selects markup.
      // This keeps availability updates working even when window.productVariants
      // is not populated.
      if (!Array.isArray(variants) || variants.length === 0) {
        try {
          const script = this.querySelector(
            'script[type="application/json"][data-variants]',
          );
          if (script && script.textContent && script.textContent.trim()) {
            const parsed = JSON.parse(script.textContent.trim());
            if (Array.isArray(parsed)) variants = parsed;
          }
        } catch (e) {
          // ignore parse errors; we'll no-op if variants is still empty
        }
      }

      if (!Array.isArray(variants) || !variants.length) return;

      // Build list of groups in DOM order (fieldsets/divs)
      const groups = Array.from(
        this.querySelectorAll(
          ".product-form__input, .product-form__input--dropdown, fieldset",
        ),
      );

      const selectedByPosition = {};
      groups.forEach((group, idx) => {
        const position =
          parseInt(group.dataset.optionPosition || "", 10) || idx + 1;
        const opt = group.querySelector("select option[selected]");
        if (opt) {
          selectedByPosition[position] = opt.value || opt.textContent || null;
          return;
        }
        const radio = group.querySelector("input:checked");
        if (radio) {
          selectedByPosition[position] = radio.value || null;
        }
      });

      groups.forEach((group, index) => {
        const optionPosition =
          parseInt(group.dataset.optionPosition || "", 10) || index + 1;
        const skipTopOptionProcessing =
          this._initialTopOptionPosition &&
          optionPosition === parseInt(this._initialTopOptionPosition, 10) &&
          !this._initialTopInteracted;
        const select = group.querySelector("select");
        if (select) {
          Array.from(select.options).forEach((option) => {
            const candidate = (
              option.value ||
              option.textContent ||
              ""
            ).toString();
            const preserveAttr =
              option.hasAttribute &&
              option.hasAttribute("data-preserve-initial-available");
            const available = variants.some((v) => {
              if (!v.available) return false;
              if ((v[`option${optionPosition}`] || "") !== candidate)
                return false;
              for (const [posKey, selectedValue] of Object.entries(
                selectedByPosition,
              )) {
                const pos = parseInt(posKey, 10);
                if (pos === optionPosition) continue;
                if (
                  selectedValue &&
                  (v[`option${pos}`] || "") !== selectedValue
                )
                  return false;
              }
              return true;
            });
            // If this specific element was marked by the server to be
            // preserved for the initial render, and the user hasn't
            // interacted yet, skip toggling its availability to avoid
            // flicker.
            if (!this._initialTopInteracted && preserveAttr) return;
            // If this is the initial-top option group and the user hasn't
            // interacted yet, preserve server-rendered state (do not
            // toggle disabled) so values remain visually enabled.
            if (skipTopOptionProcessing) return;

            if (available) {
              option.classList.remove("disabled");
              option.removeAttribute("aria-disabled");
              option.removeAttribute("disabled");
            } else {
              option.classList.add("disabled");
              option.setAttribute("aria-disabled", "true");
              option.removeAttribute("disabled");
            }
          });
        } else {
          const inputs = Array.from(
            group.querySelectorAll(
              'input[type="radio"], input[data-option-value-id]',
            ),
          );
          inputs.forEach((input) => {
            const candidate = (
              input.value ||
              input.getAttribute("value") ||
              ""
            ).toString();
            const preserveAttr = input?.hasAttribute(
              "data-preserve-initial-available",
            );
            const optionName =
              group.querySelector("legend")?.textContent.trim() || "Option";
            const available = variants.some((v) => {
              if (!v.available) return false;
              if ((v[`option${optionPosition}`] || "") !== candidate)
                return false;
              for (const [posKey, selectedValue] of Object.entries(
                selectedByPosition,
              )) {
                const pos = parseInt(posKey, 10);
                if (pos === optionPosition) continue;
                if (
                  selectedValue &&
                  (v[`option${pos}`] || "") !== selectedValue
                )
                  return false;
              }
              return true;
            });

            // If this specific element was marked by the server to be
            // preserved for the initial render, and the user hasn't
            // interacted yet, skip toggling its availability to avoid
            // flicker.
            if (!this._initialTopInteracted && preserveAttr) return;
            // Respect initial-top skipping similarly for radio/swatch inputs.
            if (skipTopOptionProcessing) return;

            if (available) {
              input.classList.remove("disabled");
              input.removeAttribute("aria-disabled");
              input.removeAttribute("disabled");
              input.setAttribute("aria-label", `${optionName} ${candidate}`);
              const swatch = group.querySelector(".swatch");
              if (swatch) swatch.classList.remove("swatch--unavailable");
            } else {
              input.classList.add("disabled");
              input.setAttribute("aria-disabled", "true");
              input.removeAttribute("disabled");
              input.setAttribute(
                "aria-label",
                `${optionName} ${candidate} - out of stock`,
              ); // e.g. "Size 6 - out of stock"
              const swatch = group.querySelector(".swatch");
              if (swatch) swatch.classList.add("swatch--unavailable");
            }
          });
        }
      });

      // Cleanup: ensure no disabled or empty-variant inputs/options remain
      // checked/selected. Be conservative: preserve the server-marked
      // initial-top option, and only clear a disabled selection when no
      // available variant actually matches the overall selected options
      // (prevents clearing when a match still exists despite a disabled
      // class being present due to transient markup states).
      try {
        const checkedElements = Array.from(
          this.querySelectorAll(
            "fieldset input:checked, input[type='radio']:checked, select option[selected]",
          ),
        );

        const currentSelected = this._getSelectedByPosition();
        const topPos = this._initialTopOptionPosition
          ? parseInt(this._initialTopOptionPosition, 10)
          : null;

        for (const el of checkedElements) {
          const preserveAttr = el.hasAttribute?.(
            "data-preserve-initial-available",
          );
          if (!this._initialTopInteracted && preserveAttr) continue;

          // Determine the option position for this element (if available)
          const elGroup = el.closest?.("[data-option-position]");
          const optionPosition =
            parseInt(el.dataset.optionPosition || "", 10) ||
            parseInt(elGroup?.dataset.optionPosition || "", 10) ||
            null;

          // Never clear the initial top option group here; we'll preserve
          // its server-rendered state to avoid flicker and accidental
          // clearing of the primary choice.
          if (optionPosition === topPos) continue;

          const isDisabled = el.disabled || el.classList?.contains("disabled");
          if (!isDisabled) return;

          // Build a candidate selected map including this element's value
          // so we can verify whether any available variant actually
          // matches the overall selected options (including this one).
          const candidateSelected = { ...currentSelected };
          if (optionPosition) {
            const val =
              el.tagName === "OPTION"
                ? el.value || el.textContent
                : el.value || el.getAttribute("value");
            if (val) candidateSelected[optionPosition] = String(val);
          }

          const matchStillExists = variants.some((v) => {
            for (const pKey in candidateSelected) {
              const selVal = candidateSelected[pKey];
              if (!selVal) continue;
              if (String(v[`option${pKey}`] || "") !== String(selVal))
                return false;
            }
            return true;
          });

          if (matchStillExists) return;

          if (el.tagName === "OPTION") {
            el.removeAttribute("selected");
          } else {
            el.checked = false;
          }

          // Update visible selection state for the group
          this.updateSelectionMetadata({ target: el });
        }
      } catch (e) {
        /* best-effort cleanup */
      }

      // Final compatibility pass: ensure no selected value remains that
      // is incompatible with the currently available variants for the
      // current selection state. This catches cases where an element
      // remained selectable but there is no available variant matching
      // the overall selected options (e.g., size stayed checked despite
      // the newly-selected color making that combo impossible).
      try {
        const finalSelected = this._getSelectedByPosition();
        const topPos = this._initialTopOptionPosition
          ? parseInt(this._initialTopOptionPosition, 10)
          : null;

        for (const [posKey, selVal] of Object.entries(finalSelected)) {
          if (!selVal) continue;
          const pos = parseInt(posKey, 10);

          const matchExists = variants.some((v) =>
            Object.entries(finalSelected).every(([pKey, val]) => {
              const p = parseInt(pKey, 10);
              return !val || String(v[`option${p}`] || "") === String(val);
            }),
          );

          if (!matchExists && pos !== topPos) {
            const group = this.querySelector(`[data-option-position="${pos}"]`);
            if (!group) continue;

            const select = group.querySelector("select");
            if (select) {
              select
                .querySelectorAll("option")
                .forEach((opt) => opt.removeAttribute("selected"));
              select.value = "";
              this.updateSelectionMetadata({ target: select });
            } else {
              const radios = group.querySelectorAll('input[type="radio"]');
              radios.forEach((r) => (r.checked = false));
              const anyInput = group.querySelector("input");
              if (anyInput) this.updateSelectionMetadata({ target: anyInput });
            }
          }
        }
      } catch (e) {
        /* best-effort final cleanup */
      }
    } catch (e) {
      console.warn("variant-selects: recalculateAvailability failed", e);
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" },
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this),
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement),
    );
    const quickBulkElement =
      this.closest("quick-order-list") || this.closest("quick-add-bulk");
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min,
        ),
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max,
        ),
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          "[step]",
          event.target.step,
        ),
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

// Function to extract, decode, and redirect to the returntocartlink URL
function redirectToCartLink() {
  // Get the URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const encodedReturnLink = urlParams.get("returntocartlink");

  // Check if the parameter exists
  if (!encodedReturnLink) {
    //console.error('No returntocartlink parameter found even though key is in the url!');
    return;
  }

  let decodedReturnLink;
  try {
    decodedReturnLink = decodeURIComponent(encodedReturnLink);

    // Validate the URL
    const urlObj = new URL(decodedReturnLink);
    window.location.href = decodedReturnLink;
  } catch (e) {
    console.error("Failed to decode or validate returntocartlink:", e);
  }
}

redirectToCartLink();

function setOnlineSToreCartAttribute() {
  const params = new URLSearchParams(window.location.search);

  const getParamOrSession = (key) => {
    const value = params.get(key);
    if (value) {
      sessionStorage.setItem(key, value);
      return value;
    }
    return sessionStorage.getItem(key);
  };

  // UTM params
  const utmCampaign = getParamOrSession("utm_campaign");
  const utmSource = getParamOrSession("utm_source");
  const utmMedium = getParamOrSession("utm_medium");

  if (!utmCampaign && !utmSource && !utmMedium) return;

  const attributes = {
    channel: "online_store",
  };

  // If any utm_* value is changing from what's already on the cart, store all
  // three utm_* values in this update (even the blank ones), and push the old
  // value onto the front of its _trail attribute (comma-separated) so we keep a
  // history of every value that utm_medium/utm_source/utm_campaign has held
  // during the session. If a key had no value before the change, a single
  // space is recorded in its trail instead of leaving that entry empty.
  const utmValues = {
    utm_campaign: utmCampaign,
    utm_source: utmSource,
    utm_medium: utmMedium,
  };

  const getCartValue = (key) => document.getElementById(`cart_${key}`)?.value;

  const anyUtmChanged = Object.entries(utmValues).some(
    ([key, newValue]) => (getCartValue(key) || "") !== (newValue || ""),
  );

  if (anyUtmChanged) {
    Object.entries(utmValues).forEach(([key, newValue]) => {
      attributes[key] = newValue || "";

      const currentValue = getCartValue(key);
      if ((currentValue || "") !== (newValue || "")) {
        const trailKey = `${key}_trail`;
        const currentTrail = getCartValue(trailKey);
        const oldValueForTrail = currentValue || " ";
        attributes[trailKey] = currentTrail
          ? `${oldValueForTrail},${currentTrail}`
          : oldValueForTrail;
      }
    });
  }

  window
    .fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes,
        sections: "announcement-bar",
      }),
    })
    .then((response) => response.json())
    .then((data) => {
      const sectionHTML = data.sections?.["announcement-bar"];
      if (!sectionHTML) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHTML, "text/html");

      const messageElement = doc.querySelector(".announcement-bar__message");
      const hasContent =
        messageElement && messageElement.textContent.trim().length > 0;

      if (!hasContent) {
        console.log("Update skipped: New announcement bar is empty.");
        return;
      }

      const sectionContainer = document.querySelector(
        '[id*="announcement-bar"]',
      );
      if (sectionContainer) {
        sectionContainer.outerHTML = sectionHTML;
      }
    })
    .catch((error) => console.error("Error updating campaign:", error));
}

setOnlineSToreCartAttribute();

// Keeps utm_attribution / utm_attribution_source in sync with the cart's utm_medium
// and utm_source.
// - On registry pages, sets utm_attribution_source ("External" on the first page of
//   the visit, "Internal" otherwise) and utm_attribution (the registry's metaobject
//   handle), each set once per cart and never overwritten after that.
// - Runs on every page: if utm_medium is present but isn't "Ride-It-Forward", any
//   previously-set utm_attribution / utm_attribution_source are cleared instead.
// - utm_source of google, listrak, or bing always forces the clear/block, even if
//   utm_medium is "Ride-It-Forward" (the utm_source check supersedes the medium check).
//   A localStorage flag remembers that the clear already happened so we don't hit
//   /cart/update.js again on every subsequent page while the block persists.
function syncUtmAttributionCartAttributes() {
  const REQUIRED_MEDIUM = "Ride-It-Forward";
  const BLOCKED_SOURCES = ["google", "listrak", "bing"];
  const CLEARED_FLAG = "utm_attribution_cleared";

  const registryEl = document.getElementById("registry");

  const isFirstPageOfVisit = !sessionStorage.getItem("visit_started");
  sessionStorage.setItem("visit_started", "true");

  const currentAttributionSource = document.getElementById(
    "cart_attribution_source",
  )?.value;
  const currentAttribution = document.getElementById("cart_attribution")?.value;
  const currentUtmMedium = document.getElementById("cart_utm_medium")?.value;
  const currentUtmSource = document.getElementById("cart_utm_source")?.value;

  const sourceBlocked =
    !!currentUtmSource &&
    BLOCKED_SOURCES.includes(currentUtmSource.toLowerCase());
  const mediumMismatch =
    !!currentUtmMedium && currentUtmMedium !== REQUIRED_MEDIUM;
  const shouldBlock = sourceBlocked || mediumMismatch;

  const attributes = {};

  if (shouldBlock) {
    const alreadyCleared = localStorage.getItem(CLEARED_FLAG) === "true";
    if (!alreadyCleared) {
      if (currentAttributionSource) attributes.utm_attribution_source = "";
      if (currentAttribution) attributes.utm_attribution = "";
      localStorage.setItem(CLEARED_FLAG, "true");
    }
  } else {
    localStorage.removeItem(CLEARED_FLAG);

    if (registryEl) {
      if (!currentAttributionSource) {
        attributes.utm_attribution_source = isFirstPageOfVisit
          ? "External"
          : "Internal";
      }

      if (!currentAttribution) {
        const metaobjectHandle = registryEl.dataset.metaobjectHandle;
        if (metaobjectHandle) {
          attributes.utm_attribution = metaobjectHandle;
        }
      }
    }
  }

  if (Object.keys(attributes).length === 0) return;

  window
    .fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes }),
    })
    .catch((error) =>
      console.error("Error syncing utm attribution attributes:", error),
    );
}

syncUtmAttributionCartAttributes();
